function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}
module.exports = _isNumber;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isNumber.js
// module id = 148
// module chunks = 33587185282056 114276838955818